import { render, staticRenderFns } from "./KeywordEditor.vue?vue&type=template&id=7e3346b4&scoped=true&"
import script from "./KeywordEditor.vue?vue&type=script&lang=js&"
export * from "./KeywordEditor.vue?vue&type=script&lang=js&"
import style0 from "./KeywordEditor.vue?vue&type=style&index=0&id=7e3346b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3346b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VCard,
  VCardText,
  VDialog,
  VForm,
  VIcon,
  VLayout,
  VSpacer,
  VTextField,
})
